<template>
  <v-container fluid pa-0>
    <v-layout row wrap justify-end align-end class="px-2 mt-1 rt-5">
      <v-flex xs6 class="text-xs-right pointer-event-auto">
        <v-btn round color="primary" @click="createBackup" :loading="btn_loading">Backup Now</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table disable-initial-sort :items="items" :loading="loading" :headers="headers">
          <template slot="items" slot-scope="{item}">
            <tr>
              <td>{{item.name}}</td>
              <td>{{item.last_modified}}</td>
              <td>{{item.size}}</td>
              <td>
                <v-tooltip top>
                  <v-icon slot="activator" @click="downloadBackup(item)">mdi-download</v-icon>
                  <span>Download</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon slot="activator" @click="deleteBackup(item)">mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      loading: false,
      btn_loading: false,
      headers: [
        {
          value: "name",
          text: "File",
          sortable: false
        },
        {
          text: "Date",
          value: "last_modified",
          sortable: false
        },
        {
          value: "size",
          text: "Size",
          sortable: false
        },
        {
          sortable: false,
          value: "name",
          text: ""
        }
      ]
    };
  },
  methods: {
    getData() {
      this.loading = true;
      this.axios
        .get(`/api/backups`)
        .then(resp => {
          this.items = resp.data;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    downloadBackup(item) {
      this.axios({
        method: "GET",
        url: `/api/backups/${item.name}`,
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.name);
        document.body.appendChild(link);
        link.click();
      });
    },
    createBackup(item) {
      this.btn_loading = true;
      this.axios
        .post("/api/backups")
        .then(res => {
          this.btn_loading = false;
          this.$snackbar.success("Backup created successfully.");
          this.getData();
        })
        .catch(err => {
          this.btn_loading = false;
        });
    },
    deleteBackup(item) {
      this.$modal.show({
        mode: "delete",
        message: "Are you sure, you want to delete this backup?",
        onConfirm: () => {
          this.axios.delete(`/api/backups/${item.name}`).then(response => {
            this.getData();
          });
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
